export function getQueryArgs(url = '', param = '') {
    if (url === '' || param === '') return undefined;
    let params = url.split('?');
    if (params && params[1]) {
        let query_args = params[1].split('&');
        let args = {};
        for (let i in query_args) {
            let q = query_args[i].split('=');
            if(q[0]) {
                args[q[0]] = q.splice(1, q.length).join('=');
            }
        }
        return args[param] ? args[param] : undefined;
    }
    return undefined;
}



// WEBPACK FOOTER //
// ./src/utils/parser/url.js